import React, { useState } from "react";

interface Props {
    documents: any[];
    showDocuments: boolean;
    setShowDocuments: (val: boolean) => void;
    getStatusBg: (status: string) => string;
}

type DocRequest = {
    docType: string;
    description: string;
    status: string;
};

const DocumentList: React.FC<Props> = ({
    documents,
    showDocuments,
    setShowDocuments,
    getStatusBg
}) => {

    const [showSubmit, setShowSubmit] = useState(false);
    const [docRequest, setDocRequest] = useState<DocRequest>({
        docType: "",
        description: "",
        status: "PENDING"
    });

    const docTypes = [
        "Bonafide",
        "ID Card",
        "Fee Receipt",
        "Transfer Certificate",
        "Conduct Certificate",
        "Other"
    ];

    const handleSubmit = () => {
        if (!docRequest.docType || !docRequest.description) {
            alert("Please fill all fields");
            return;
        }
        console.log("Submitted:", docRequest);
        setDocRequest({
            docType: "",
            description: "",
            status: "PENDING"
        });
        setShowSubmit(false);
    };

    return (
        <div className="event-container">
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <h3 style={{ margin: 0 }}>
                    <i className="fa-solid fa-folder"></i> Documents
                </h3>
                <i
                    className={`fa-solid ${showDocuments ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                    onClick={() => setShowDocuments(!showDocuments)}
                    style={{ cursor: "pointer" }}
                />
            </div>
            {showDocuments && (
                <>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "8px"
                        }}
                    >
                        <span
                            style={{
                                fontWeight: 600,
                                color: "var(--colorPrimaryDark)"
                            }}
                        >
                            Submit Document
                        </span>
                        {!showSubmit ? (
                            <i
                                className="fa-solid fa-plus"
                                onClick={() => setShowSubmit(true)}
                                style={{
                                    cursor: "pointer",
                                    color: "#e0544d",
                                    fontSize: "16px"
                                }}
                            />
                        ) : (
                            <i
                                className="fa-solid fa-xmark"
                                onClick={() => setShowSubmit(false)}
                                style={{
                                    cursor: "pointer",
                                    color: "#e0544d",
                                    fontSize: "16px"
                                }}
                            />
                        )}
                    </div>
                    {showSubmit && (
                        <div
                            style={{
                                marginTop: "12px",
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "12px",
                                padding: "14px"
                            }}
                        >
                            <select
                                value={docRequest.docType}
                                onChange={(e) =>
                                    setDocRequest({
                                        ...docRequest,
                                        docType: e.target.value
                                    })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "10px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    boxSizing: "border-box"
                                }}
                            >
                                <option value="">Select Type</option>
                                {docTypes.map((t, i) => (
                                    <option key={i} value={t}>
                                        {t}
                                    </option>
                                ))}
                            </select>
                            <textarea
                                rows={3}
                                placeholder="Description"
                                value={docRequest.description}
                                onChange={(e) =>
                                    setDocRequest({
                                        ...docRequest,
                                        description: e.target.value
                                    })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    resize: "none",
                                    boxSizing: "border-box"
                                }}
                            />
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: "10px"
                                }}
                            >
                                <button
                                    onClick={handleSubmit}
                                    style={{
                                        background: "var(--colorPrimaryDark)",
                                        color: "#fff",
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "bold"
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    )}
                    {documents.map((doc, index) => (
                        <div
                            key={doc.id ?? index}
                            style={{
                                background: "#fff",
                                border: "1px solid #e5e5e5",
                                borderRadius: "12px",
                                padding: "18px",
                                marginTop: "14px",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                            }}
                        >
                            <h3 style={{ margin: 0, color: "#e0544d" }}>
                                {doc.name}
                            </h3>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: "22px",
                                    alignItems: "flex-end",
                                }}
                            >
                                <span
                                    style={{
                                        background: getStatusBg(doc.status),
                                        color: "#fff",
                                        padding: "6px 18px",
                                        borderRadius: "6px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                    }}
                                >
                                    {(doc.status || "PENDING").toUpperCase()}
                                </span>

                                <div style={{ textAlign: "right" }}>
                                    <div style={{ color: "#888", fontSize: "14px" }}>
                                        Date Submitted on :
                                    </div>
                                    <div style={{ fontWeight: 700, fontSize: "18px" }}>
                                        {doc.submittedDate || "N/A"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default DocumentList;